import React, { Component } from 'react'
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import ButtonCardBack from './ButtonCardBack';

import { actions as pharmacyActions } from '../pharmacy/ducks/session';
import { actions as doctorActions } from '../doctor/ducks/session';
import { actions as customerActions } from '../ducks/session';

class NavItem extends Component {

  render() {
    // eslint-disable-next-line no-restricted-globals
    const currentLocation = location.pathname;
    const classStr = currentLocation === this.props.to ? 'active' : ''
  
    return (
        <Link to={this.props.to} className={classStr}>{this.props.linkName}</Link>
      )
  }
}

const NavigationContainer = (props) => (
  <div className="navigation__desktop-container">
    {
        props.cartDirty ?
        <Link to="/handling" className="checkout-link" id="btn-siirry-kassalle">
          <div className="checkout active">
            <div>Siirry kassalle</div>
            <div className="price">{props.cartPriceEuro}</div>
          </div>
        </Link>
        :
        null
      }
      <div className="navigation__desktop">
        {props.loggedIn ? '' : (
            <ButtonCardBack />
          )}
          <h1 className="logo">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 165 65.89"><title>Logo</title><g id="Layer_2" data-name="Layer 2"><g id="Musta"><path id="Rectangle_1195" data-name="Rectangle 1195" d="M20.92,63.78h0a4.66,4.66,0,0,1-4.66-4.66h0a4.66,4.66,0,0,1,4.66-4.67h0a4.66,4.66,0,0,1,4.66,4.67h0A4.66,4.66,0,0,1,20.92,63.78Z"/><path id="Path_1078" data-name="Path 1078" d="M72.25,65.89a2,2,0,0,1-1.89-2.6c3.24-9.58,5.92-18.56,5.93-28.8s-2.7-21.68-6-31.68A2,2,0,0,1,72.26.22h58.68c19.36,0,35.26,16,34,35a33.1,33.1,0,0,1-33.19,30.65H72.25Z"/><rect id="Rectangle_1187" data-name="Rectangle 1187" x="52.6" y="52.54" width="13" height="13" rx="6.5" ry="6.5"/><path id="Rectangle_1188" data-name="Rectangle 1188" d="M63.88,49.06h0a6.5,6.5,0,0,1-6.5-6.5h0a6.5,6.5,0,0,1,6.5-6.5h0a6.5,6.5,0,0,1,6.5,6.5h0A6.5,6.5,0,0,1,63.88,49.06Z"/><path id="Rectangle_1189" data-name="Rectangle 1189" d="M64,32.13h0a6.5,6.5,0,0,1-6.5-6.5h0a6.5,6.5,0,0,1,6.5-6.5h0a6.5,6.5,0,0,1,6.5,6.5h0A6.5,6.5,0,0,1,64,32.13Z"/><path id="Rectangle_1190" data-name="Rectangle 1190" d="M58.75,13h0a6.5,6.5,0,0,1-6.5-6.5h0A6.5,6.5,0,0,1,58.75,0h0a6.5,6.5,0,0,1,6.5,6.5h0A6.5,6.5,0,0,1,58.75,13Z"/><rect id="Rectangle_1191" data-name="Rectangle 1191" x="34.49" y="53.04" width="12" height="12" rx="6" ry="6"/><path id="Rectangle_1193" data-name="Rectangle 1193" d="M44,32.13h0a6.5,6.5,0,0,1-6.5-6.5h0a6.5,6.5,0,0,1,6.5-6.5h0a6.5,6.5,0,0,1,6.5,6.5h0A6.5,6.5,0,0,1,44,32.13Z"/><path id="Rectangle_1194" data-name="Rectangle 1194" d="M39.47,13h0a6,6,0,0,1-6-6h0a6,6,0,0,1,6-6h0a6,6,0,0,1,6,6h0A6,6,0,0,1,39.47,13Z"/><path id="Rectangle_1196" data-name="Rectangle 1196" d="M24.45,30.63h0a5,5,0,0,1-5-5h0a5,5,0,0,1,5-5h0a5,5,0,0,1,5,5h0A5,5,0,0,1,24.45,30.63Z"/><path id="Rectangle_1197" data-name="Rectangle 1197" d="M20.19,12h0a4.81,4.81,0,0,1-4.82-4.81h0A4.82,4.82,0,0,1,20.19,2.4h0A4.82,4.82,0,0,1,25,7.21h0A4.81,4.81,0,0,1,20.19,12Z"/><path id="Rectangle_1201" data-name="Rectangle 1201" d="M45.16,47.23h0a4.67,4.67,0,0,1-4.68-4.67h0a4.67,4.67,0,0,1,4.68-4.67h0a4.68,4.68,0,0,1,4.68,4.67h0A4.68,4.68,0,0,1,45.16,47.23Z"/><path id="Rectangle_1223" data-name="Rectangle 1223" d="M4.89,30.51h0A4.89,4.89,0,0,1,0,25.63H0a4.89,4.89,0,0,1,4.89-4.88h0a4.89,4.89,0,0,1,4.89,4.88h0A4.89,4.89,0,0,1,4.89,30.51Z"/></g></g></svg>
            { process.env.REACT_APP_PROJECT_NAME }
            <div>{ props.renderStaticContent && props.renderStaticContent() }</div>
            
          </h1>
          { props.loggedIn && props.renderMessage ? props.renderMessage() : ''  }
          { props.loggedIn ? props.renderNavItems() : '' }
      </div>
  </div>
)

const CustomerNavigation = (props) => {
  const { chatButton, openChat, location, logout } = props;
  let renderedChatButton = null;
    if (chatButton) {
      renderedChatButton = <button className="button__add tablet" onClick={openChat}>
                <svg xmlns="http://www.w3.org/2000/svg" className="add_recipe" viewBox="0 0 27 27">
                  <g id="Layer_2" data-name="Layer 2">
                    <g id="Layer_1-2" data-name="Layer 1"><path d="M25.5,15H1.5a1.5,1.5,0,0,1,0-3h24a1.5,1.5,0,0,1,0,3Z"/><path d="M13.5,27A1.5,1.5,0,0,1,12,25.5V1.5a1.5,1.5,0,0,1,3,0v24A1.5,1.5,0,0,1,13.5,27Z"/>
                    </g>
                  </g>
                </svg>
              </button>
    }

  const navItems = 
  <nav>
    <NavItem to="/reseptit" linkName="Reseptit" currentPath={location.pathname} />
    { renderedChatButton }
    <NavItem to="/profile" linkName="Oma tili" currentPath={location.pathname} />
    <Link to="/" className="logout" onClick={logout}>Kirjaudu ulos</Link>
  </nav>

  return (
    <NavigationContainer renderNavItems = { () => navItems } {...props}/>
  );
}

const DoctorNavigation = (props) => {
  const { firstName, lastName, navMessage } = props;
  const doctorName = (firstName && lastName) ? <span> { firstName + ' ' + lastName } </span> : null;
  
  const message = (navMessage) ? 
   (navMessage.status === 'published') ?
    <span className="navigation-message-wrapper"><span className="navigation-message">{navMessage.header}</span></span> : null 
  : null

  const navItems = 
    <nav>
      <NavItem to="/doctor" linkName="Tilaukset" />
      <NavItem to="/doctor/history" linkName="Historia" />
      <NavItem to="/doctor/admin" linkName="Admin" />
      <button type="button" className="logout link-button" onClick={ () => props.logout() } >Kirjaudu ulos </button>
    </nav>

    return (
      <NavigationContainer renderStaticContent = { () => doctorName } renderMessage={ () => message } renderNavItems={ () => navItems } { ...props } />
    );
}

const PharmacyNavigation = (props) => {
  const { navMessage, handleNotification } = props;
  const pharmacyName = props.apteekki ? <span className="pharmacy-title">{props.apteekki.pharmacyName}</span> : null;

  //const activeStyle = checkStatus ? "active" : ""
  const activeStyle = "active"
  
  const message = (navMessage) ? 
   (navMessage.status === "published") ?
    <span className={`navigation-message-wrapper ${activeStyle}`} onClick={handleNotification}><span className="navigation-message">{navMessage.header}</span></span> : null 
  : null

  const navItems = 
    <nav>
      { props.loggedIn && <NavItem to="/reseptitapteekki" linkName="Työpöytä" /> }
      { props.loggedIn && props.isAdmin && <NavItem to="/adminapteekki" linkName="Järjestelmänvalvoja" /> }
      { props.loggedIn && <Link to="/" className="logout" onClick={(e) => props.logout()}>Kirjaudu ulos</Link> }
    </nav>

  return (
    <NavigationContainer renderStaticContent = { () => pharmacyName } renderMessage={ () => message } renderNavItems={ () => navItems } { ...props } />
  );
}

const NavigationBar =  withRouter(connect(state => ({}), { logout: customerActions.logout })(CustomerNavigation));
const ConnectedDoctorNavigation =  withRouter(connect(state => ({}), { logout: doctorActions.logout })(DoctorNavigation));
const ConnectedPharmacyNavigation = withRouter(connect(state => ({}), { logout: pharmacyActions.logout })(PharmacyNavigation));

export { NavigationBar as default, ConnectedDoctorNavigation as DoctorNavigationBar, ConnectedPharmacyNavigation as PharmacyNavigation };